import * as types from './action-types';
import { history } from "../store/configure-store";

export const setCurrentSlide = (index) => {
  history.push(`#slide-${index}`);
  return {
    type: types.SET_CURRENT_SLIDE,
    index
  }
};

export const enableSlides = () => {
  return {
    type: types.ENABLE_SLIDES,
  }
};

export const disableSlides = () => {
  return {
    type: types.DISABLE_SLIDES,
  }
};

export const resetFolio = () => {
  return {
    type: types.RESET_FOLIO
  }
};

export const toggleFolioNav = () => {
  history.push(`/folio`);
  return {
    type: types.TOGGLE_FOLIO_NAVIGATION,
  };
};

export const showNotification = (notification, dismissable) => {
  return {
    type: types.SHOW_NOTIFICATION, notification, dismissable
  };
};

export const hideNotification = () => {
  return {
    type: types.HIDE_NOTIFICATION
  };
};

export const redirectToLogin = () => {
  history.push('/login');
  return {
    type: types.REDIRECT_TO_LOGIN
  };
};

export const redirectToAdmin = () => {
  history.push('/admin/projects');
  return {
    type: types.REDIRECT_TO_ADMIN
  };
};



// WEBPACK FOOTER //
// ./src/actions/folio-actions.js